import { type Options, useHotkeys } from "react-hotkeys-hook";

import type { SHORTCUT } from "@/lib/shortcuts";

const TIPTAP_COMPOSER_SELECTOR = ".bk-composer .tiptap";

export function isInsideTiptap(): boolean {
  if (typeof document === "undefined") return false;
  const el = document.activeElement;
  if (!el || el === document.body) return false;
  return !!el.closest(TIPTAP_COMPOSER_SELECTOR);
}

export function useShortcut(shortcut: SHORTCUT, handler: (e: KeyboardEvent) => void, options?: Options) {
  return useHotkeys(
    shortcut,
    (e: KeyboardEvent) => {
      if (isInsideTiptap()) return;
      handler(e);
    },
    {
      preventDefault: true,
      ...options,
    },
  );
}
